module.exports = __webpack_public_path__ + "static/media/icon_huodon_sj.726f1355.png";